var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn integration-status-indicator",class:_vm.connected ? 'integration-status-indicator__connected' : 'integration-status-indicator__disabled'},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.connected ? 'Connected' : 'Configure to Activate')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }